/* eslint eqeqeq: "off" */
import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import PropTypes from "prop-types";
import {
  Col,
  Row,
  Skeleton,
  //   DatePicker,
  Table,
  Select,
  AutoComplete,
  Input,
  Spin,
  // Button,
} from "antd";
import "./index.css";
import { DownloadOutlined } from "@ant-design/icons";
// import { useHistory } from "react-router";
import { BiCalendar } from "react-icons/bi";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { isEmpty } from "lodash";
import useMedia from "use-media-antd-query";
import { loadSalesItemQtyReport } from "../../store/reports/actions";
import DatePicker from "react-datepicker";
import api from "../../helpers";
import { loadParties } from "../../store/parties/actions";

const SalesItemsQtyReport = (props) => {
  const dispatch = useDispatch();

  //organisation id from login response
  const userValues = localStorage.getItem("authData");

  const userNameDetails = JSON.parse(userValues);

  const organizationId =
    !isEmpty(userNameDetails) &&
    userNameDetails.user &&
    userNameDetails.user.organizations.length > 0
      ? userNameDetails.user.organizations[0].organizationId
      : "";

  //   const startOfMonth = moment().startOf("month").format("YYYY-MM-DD");
  //   const endOfMonth = moment().endOf("month").format("YYYY-MM-DD");
  const media = useMedia();

  const stockGetPayload = {
    organizationId: organizationId,
    page: 1,
    limit: 10,
  };

  //initial state values
  const [loading, setLoading] = useState(false);
  const [tableLoading, setTableLoading] = useState(false);
  const [partyList, setPartyList] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [downloadLoading, setDownloadLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    setTableLoading(true);
    setTimeout(() => {
      setTableLoading(false);
      setLoading(false);
    }, 2000);
    dispatch(loadSalesItemQtyReport(stockGetPayload));
    dispatch(
      loadParties({
        organizationId: organizationId,
      })
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // reducer state
  const { sales_item_quantity_report = {} } = useSelector(
    (state) => state.Reports
  );
  const { parties_list = {} } = useSelector((state) => state.Parties);

  const partyOptions =
    parties_list && parties_list.length > 0
      ? parties_list.map((data) => {
          return { value: data._id, label: data.partyName };
        })
      : [];
  //header columns
  const HeaderData = [
    {
      key: "createdAt",
      title: <p className="header-purchase-invoice font-semibold">Date</p>,
      dataIndex: "createdAt",
      width: 120,
      // fixed: "left",
      sorter: (a, b) => a.createdAt.length - b.createdAt.length,
    },
    {
      key: "billNo",
      title: <p className="header-purchase-invoice font-semibold">Bill No</p>,
      dataIndex: "billNo",
      width: 120,
    },
    {
      key: "partyName",
      title: (
        <p className="header-purchase-invoice font-semibold">Party Name</p>
      ),
      dataIndex: "partyName",
      width: 150,
    },
    {
      key: "brandName",
      title: (
        <p className="header-purchase-invoice font-semibold">Brand Name</p>
      ),
      dataIndex: "brandName",
      width: 150,
    },
    {
      key: "modelName",
      title: (
        <p className="header-purchase-invoice font-semibold">Model Name</p>
      ),
      dataIndex: "modelName",
      width: 150,
    },
    {
      key: "totalQty",
      title: <p className="header-purchase-invoice font-semibold">Total Qty</p>,
      dataIndex: "totalQty",
      width: 100,
    },
    {
      key: "discountAmount",
      title: (
        <p className="header-purchase-invoice font-semibold">Discount Price</p>
      ),
      dataIndex: "discountAmount",
      width: 130,
    },
    {
      key: "totalAmount",
      title: (
        <p className="header-purchase-invoice font-semibold">Total Amount</p>
      ),
      dataIndex: "totalAmount",
      width: 140,
    },
    // {
    //   key: "products",
    //   title: <p className="header-purchase-invoice font-semibold">Items</p>,
    //   dataIndex: "products",
    // },
    // {
    //   key: "status",
    //   title: <p className="header-purchase-invoice font-semibold">Status</p>,
    //   dataIndex: "status",
    //   width: 150,
    // },
  ];

  //filters
  const [pageValue, setPageValue] = useState("");
  //   const [filteredValues, setFilteredValues] = useState("");
  //   const [dateReset, setDateReset] = useState(false);
  const applyFilters = () => {
    var fromDateFilter = fromDate ? moment(fromDate).format("YYYY-MM-DD") : "";
    var toDateFilter = toDate ? moment(toDate).format("YYYY-MM-DD") : "";
    var partyId =
      !isEmpty(partyList) || partyList.length !== 0 ? partyList : "";

    let searchValue = {};
    searchValue.page = pageValue ? pageValue : 1;
    searchValue.limit = 10;
    searchValue.organizationId = organizationId;

    if (fromDateFilter) {
      searchValue.fromDate = fromDateFilter;
    }
    if (toDateFilter) {
      searchValue.toDate = toDateFilter;
    }
    if (!isEmpty(partyId)) {
      searchValue.partyId = partyId;
    }
    // setFilteredValues(searchValue);
    setTableLoading(true);
    setTimeout(() => {
      setTableLoading(false);
    }, 2000);
    dispatch(loadSalesItemQtyReport(searchValue));
  };

  const [salesItemQtyRows, setSalesItemQtyRows] = useState([
    {
      key: "",
      _id: "",
      discountAmount: "",
      gradeName: "",
      billNo: "",
      brandName: "",
      modelName: "",
      partyName: "",
      createdAt: "",
      totalAmount: "",
      totalQty: "",
    },
  ]);

  const itemQuantityReportTable =
    !isEmpty(sales_item_quantity_report) &&
    sales_item_quantity_report.data.length > 0
      ? sales_item_quantity_report.data.map((data, index) => {
          return {
            key: index + 1,
            discountAmount: data.discountAmount,
            gradeName: data.gradeName,
            modelName: data.modelName,
            totalAmount: data.totalAmount,
            billNo: data.billNo,
            brandName: data.brandName,
            totalQty: data.totalQty,
            createdAt: data.createdAt
              ? moment(data.createdAt).format("DD-MM-YYYY")
              : "",
            purchaseinvoiceNo: data.purchaseinvoiceNo,
            partyName: data.partyName,
            _id: data._id,
            status: data.status,
          };
        })
      : [];

  useEffect(() => {
    if (itemQuantityReportTable && itemQuantityReportTable.length > 0) {
      setSalesItemQtyRows(itemQuantityReportTable);
    } else {
      setSalesItemQtyRows([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sales_item_quantity_report]);

  //paginations
  const handlePagination = (data) => {
    setPageValue(data);
    dispatch(
      loadSalesItemQtyReport({
        page: data,
        limit: 10,
        organizationId: organizationId,
      })
    );
    setTableLoading(true);
    setTimeout(() => {
      setTableLoading(false);
    }, 2000);
  };

  //search , print and download
  const [search, setSearch] = useState("");

  const handleSearch = (event) => {
    const filteredRows = itemQuantityReportTable
      .filter((row) =>
        row.partyName.toLowerCase().includes(event.target.value.toLowerCase())
      )
      .filter((item, index, self) => self.indexOf(item) === index); // Remove duplicates

    setSearch(event.target.value);
    setSalesItemQtyRows(filteredRows);
    setTableLoading(true);
    setTimeout(() => {
      setTableLoading(false);
    }, 2000);
  };

  //Download functionality

  //Download functionality
  const downloadFile = ({ data, fileName, fileType }) => {
    const blob = new Blob([data], { type: fileType });

    const a = document.createElement("a");
    a.download = fileName;
    a.href = window.URL.createObjectURL(blob);
    const clickEvt = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    });
    a.dispatchEvent(clickEvt);
    a.remove();
  };

  const handleDownloadPDF = () => {
    setDownloadLoading(true);
    var fromDateFilter = fromDate ? moment(fromDate).format("YYYY-MM-DD") : "";
    var toDateFilter = toDate ? moment(toDate).format("YYYY-MM-DD") : "";
    var partyId =
      !isEmpty(partyList) || partyList.length !== 0 ? partyList : "";

    let searchValue = {};
    searchValue.organizationId = organizationId;

    if (fromDateFilter) {
      searchValue.fromDate = fromDateFilter;
    }
    if (toDateFilter) {
      searchValue.toDate = toDateFilter;
    }
    if (!isEmpty(partyId)) {
      searchValue.partyId = partyId;
    }
    api
      .post(`/org/getsalesitemwisereportexcel`, searchValue)
      .then((response) => {
        const stockReportExcel =
          !isEmpty(response) && response.data.length > 0
            ? response.data.map((data, index) => {
                return {
                  key: index + 1,
                  discountAmount: data.discountAmount,
                  gradeName: data.gradeName,
                  modelName: data.modelName,
                  brandName: data.brandName,
                  billNo: data.billNo,
                  totalAmount: data.totalAmount,
                  totalQty: data.totalQty,
                  purchaseinvoiceDate: data.createdAt
                    ? moment(data.createdAt).format("DD-MM-YYYY")
                    : "",
                  purchaseinvoiceNo: data.purchaseinvoiceNo,
                  partyName: data.partyName,
                  _id: data._id,
                };
              })
            : [];
        setTimeout(() => {
          let headerData = [
            "S.No, Date,Bill No,Party Name,BrandName,Model Name, Qty,Discount Price, Total",
          ];

          let usersCsv = !isEmpty(stockReportExcel)
            ? stockReportExcel.reduce((acc, user) => {
                const {
                  key,
                  purchaseinvoiceDate,
                  billNo,
                  partyName,
                  brandName,
                  modelName,
                  totalQty,
                  discountAmount,
                  totalAmount,
                } = user;
                acc.push([
                  key,
                  purchaseinvoiceDate,
                  billNo,
                  partyName,
                  brandName,
                  modelName,
                  totalQty,
                  discountAmount,
                  totalAmount,
                ]);

                return acc;
              }, [])
            : false;

          const usersList =
            !isEmpty(usersCsv) && usersCsv.length > 0 ? usersCsv : [];

          downloadFile({
            data: [...headerData, ...usersList].join("\n"),
            fileName: "SalesItemQtyReport.csv",
            fileType: "text/csv",
          });
          setDownloadLoading(false);
        }, 2500);
        return response.data;
      })
      .catch((error) => Promise.reject(error));
  };

  //window height/width
  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <React.Fragment>
      <div className="">
        <MetaTags>
          <title>Sales Item Quantity Report | Mbook</title>
        </MetaTags>
      </div>

      <Row className="border-solid rounded-sm bg-[#ffffff]">
        <Col span={24}>
          <div className="font-poppins border border-b-1 border-x-0 border-t-0 pl-[20px] pr-[20px] mt-2 pb-2">
            <div className="flex">
              <h1
                style={{
                  fontFamily: "Poppins",
                }}
                className="text-[16px] font-semibold"
              >
                Sales Item Quantity Report
              </h1>
            </div>
          </div>
        </Col>
      </Row>
      <Row
        className={
          windowDimensions.height > 500 && windowDimensions.height <= 600
            ? "sales-item-qty-reports-tab-device"
            : windowDimensions.height > 600 && windowDimensions.height <= 700
            ? "sales-item-qty-reports-medium-device"
            : windowDimensions.height > 700 && windowDimensions.height <= 830
            ? "sales-item-qty-reports-large-device"
            : windowDimensions.height > 830 && windowDimensions.height <= 900
            ? "sales-item-qty-reports-extra-large-device"
            : windowDimensions.height > 900 && windowDimensions.height <= 1000
            ? "sales-item-qty-reports-extra-extra-large-device"
            : windowDimensions.height > 1000
            ? "sales-item-qty-reports-extra-infinite-large-device"
            : "sales-item-qty-reports"
        }
      >
        <Col
          md={24}
          lg={24}
          sm={24}
          xs={24}
          className={
            windowDimensions.height > 700
              ? "mt-2 pr-4 pl-4 pt-3 mb-4 bg-[#ffffff] h-[15%] rounded-md"
              : "mt-2 pr-4 pl-4 pt-3 pb-2 mb-4 bg-[#ffffff] h-[15%] rounded-md"
          }
        >
          {" "}

          <Row className="pr-2 pl-2 pt-3 pb-2 rounded-md">
            <Col md={6} lg={6} sm={24} xs={24} className="pr-3">
              {loading ? (
                <Skeleton.Input
                  style={{
                    width:
                      media == "md"
                        ? "180px"
                        : media == "sm"
                        ? "300px"
                        : "250px",
                    height: "35px",
                  }}
                ></Skeleton.Input>
              ) : (
                <Select
                  value={partyList}
                  onChange={(newValue) => setPartyList(newValue)}
                  placeholder="Select Party"
                  options={partyOptions}
                  style={{
                    fontFamily: "Poppins",
                  }}
                  className={
                    media == "sm"
                      ? "w-[366px] h-[40px]"
                      : media == "xs"
                      ? "w-[230px] h-[40px]"
                      : "w-[100%] h-[40px]"
                  }
                />
              )}
            </Col>
            <Col
              md={5}
              lg={5}
              sm={24}
              xs={24}
              className={media == "sm" || media == "xs" ? "mt-2 pr-3" : "pr-3"}
            >
              {loading ? (
                <Skeleton.Input
                  style={{
                    width:
                      media == "md"
                        ? "180px"
                        : media == "sm"
                        ? "300px"
                        : "250px",
                    height: "35px",
                    marginBottom: media == "sm" || media == "xs" ? "5px" : "",
                  }}
                ></Skeleton.Input>
              ) : (
                <DatePicker
                  toggleCalendarOnIconClick={true}
                  selected={fromDate}
                  className={
                    media == "sm"
                      ? "rounded-md border border-1 h-[40px] w-[200%] mt-2"
                      : media == "xs"
                      ? "rounded-md border border-1 h-[40px] w-[125%] mt-2"
                      : media == "lg" || media == "md"
                      ? "rounded-md border border-1 h-[40px] w-[100%]"
                      : "rounded-md border border-1 h-[40px] w-[130%]"
                  }
                  style={{
                    fontFamily: "Poppins",
                  }}
                  onChange={(date) => setFromDate(date)}
                  icon={
                    <BiCalendar
                      //   size={30}
                      className={
                        media == "sm"
                          ? "top-[12px] text-[16px] right-[-183px] text-[#9e9e9e]"
                          : media == "xs"
                          ? "top-[12px] text-[16px] right-[-30px] text-[#9e9e9e]"
                          : media == "lg" || media == "md"
                          ? "top-[5px] text-[16px] right-[3px] text-[#9e9e9e]"
                          : "top-[5px] text-[16px] right-[-50px]  text-[#9e9e9e]"
                      }
                    />
                  }
                  showIcon
                  placeholderText="Select From Date"
                />
              )}
            </Col>
            <Col
              md={5}
              lg={5}
              sm={24}
              xs={24}
              className={media == "sm" || media == "xs" ? "mt-2 pr-3" : "pr-3"}
            >
              {loading ? (
                <Skeleton.Input
                  style={{
                    width:
                      media == "md"
                        ? "180px"
                        : media == "sm"
                        ? "300px"
                        : "250px",
                    height: "35px",
                    marginBottom: media == "sm" || media == "xs" ? "5px" : "",
                  }}
                ></Skeleton.Input>
              ) : (
                <DatePicker
                  toggleCalendarOnIconClick={true}
                  selected={toDate}
                  className={
                    media == "sm"
                      ? "rounded-md border border-1 h-[40px] w-[200%] mt-2"
                      : media == "xs"
                      ? "rounded-md border border-1 h-[40px] w-[125%] mt-2"
                      : media == "lg" || media == "md"
                      ? "rounded-md border border-1 h-[40px] w-[100%]"
                      : "rounded-md border border-1 h-[40px] pl-1 w-[130%]"
                  }
                  style={{
                    fontFamily: "Poppins",
                  }}
                  onChange={(date) => setToDate(date)}
                  icon={
                    <BiCalendar
                      //   size={30}
                      className={
                        media == "sm"
                          ? "top-[12px] text-[16px] right-[-183px] text-[#9e9e9e]"
                          : media == "xs"
                          ? "top-[12px] text-[16px] right-[-30px] text-[#9e9e9e]"
                          : media == "lg" || media == "md"
                          ? "top-[5px] text-[16px] right-[3px] text-[#9e9e9e]"
                          : "top-[5px] text-[16px] right-[-50px]  text-[#9e9e9e]"
                      }
                    />
                  }
                  popperClassName={"z-10 ml-3"}
                  showIcon
                  placeholderText="Select To Date"
                />
              )}
            </Col>
            <Col
              md={7}
              lg={7}
              sm={24}
              xs={24}
              className={
                media == "sm" || media == "xs" ? "pr-2 w-[100%] mt-3" : "pr-2"
              }
            >
              <Row className="">
                <Col
                  md={12}
                  lg={12}
                  sm={24}
                  xs={24}
                  className="pl-0 md:pl-10 lg:pl-10 xl:pl-10"
                >
                  {loading ? (
                    <Skeleton.Input
                      style={{
                        width:
                          media == "md"
                            ? "180px"
                            : media == "sm"
                            ? "300px"
                            : "250px",
                        height: "35px",
                      }}
                    ></Skeleton.Input>
                  ) : (
                    <div
                      className={
                        media == "sm" || media == "xs"
                          ? "flex w-[100%]"
                          : "flex"
                      }
                    >
                      <div
                        style={{
                          fontFamily: "Poppins",
                          fontSize: "13px",
                        }}
                        onClick={() => {
                          setFromDate("");
                          setToDate("");
                          setTableLoading(true);
                          setTimeout(() => {
                            setTableLoading(false);
                          }, 2000);
                          setPartyList([]);
                          dispatch(loadSalesItemQtyReport(stockGetPayload));
                        }}
                        className={
                          media == "sm" || media == "xs"
                            ? "cursor-pointer ml-0 text-[#ffffff] text-center rounded-md pt-2 pb-2 pl-5 pr-5 mr-2 bg-[#eb4d1b] hover hover:bg-[red]"
                            : "cursor-pointer ml-5 text-[#ffffff] text-center rounded-md pt-2 pb-2 pl-5 pr-5 mr-2 bg-[#eb4d1b] hover hover:bg-[red]"
                        }
                      >
                        Reset
                      </div>
                      <div
                        style={{
                          fontFamily: "Poppins",
                          fontSize: "13px",
                        }}
                        onClick={() => applyFilters()}
                        className="cursor-pointer ml-1 text-[#ffffff] text-center rounded-md pt-2 pb-2 pl-5 pr-5 bg-[#45bd4a] hover hover:bg-[green]"
                      >
                        Filter
                      </div>
                    </div>
                  )}
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
        {/* print, download section */}
        <Col
          md={24}
          lg={24}
          sm={24}
          xs={24}
          className={
            windowDimensions.height > 700 && windowDimensions.height <= 830
              ? "mt-[1px] h-[100%] bg-[#ffffff] rounded-md"
              : windowDimensions.height > 830 && windowDimensions.height <= 1000
              ? "mt-[1px] h-[100%] bg-[#ffffff] rounded-md"
              : // : windowDimensions.height > 900 && windowDimensions.height < 1000
              // ? "mt-[-232px] bg-[#ffffff] rounded-md"
              windowDimensions.height > 1000
              ? "mt-[-10px] h-[100%] bg-[#ffffff] rounded-md"
              : "bg-[#ffffff] rounded-md"
          }
        >
          <Row className="flex flex-col">
            <Col md={24} lg={24} sm={24} xs={24} className="mt-4 mb-3 pb-5">
              <Row className="flex justify-between">
                <Col
                  md={10}
                  lg={10}
                  sm={18}
                  xs={18}
                  className="pr-3 lg:pr-0 md:pr-0 pl-4"
                >
                  {loading ? (
                    <Skeleton.Input
                      style={{
                        width:
                          media == "md"
                            ? "180px"
                            : media == "sm"
                            ? "300px"
                            : "180px",
                        height: "35px",
                      }}
                    ></Skeleton.Input>
                  ) : (
                    <div className="w-[100%] lg:w-[65%] md:w-[65%]">
                      <AutoComplete
                        style={{
                          marginRight: "10px",
                          fontSize: "11px",
                        }}
                        // onClick={() => setSearchOpen(false)}
                        className="w-[100%]"
                      >
                        <Input.Search
                          size="middle"
                          placeholder="Search Party"
                          style={{
                            fontFamily: "Poppins",
                            // minHeight: "35px",
                            fontSize: "11px",
                          }}
                          name="search"
                          value={search}
                          onChange={(e) => handleSearch(e)}
                        />
                      </AutoComplete>
                    </div>
                  )}
                </Col>
                <Col md={14} lg={14} sm={18} xs={18} className="pr-1">
                  <Row className="flex justify-end">
                    <Col
                      md={7}
                      lg={7}
                      sm={24}
                      xs={24}
                      className="pr-3 sm:pr-3 ml-3 sm:ml-3 mt-3 lg:mt-0 md:mt-0 lg:ml-10 md:ml-10"
                    >
                      {loading ? (
                        <Skeleton.Input
                          style={{
                            width:
                              media == "md"
                                ? "180px"
                                : media == "sm"
                                ? "300px"
                                : "180px",
                            paddingRight: media == "md" ? "20px" : "14px",
                            marginLeft:
                              media == "sm" || media == "xs" ? "20px" : "0px",
                            height: "35px",
                          }}
                        ></Skeleton.Input>
                      ) : (
                        <Row>
                          <Col
                            md={24}
                            lg={24}
                            sm={24}
                            xs={24}
                            onClick={handleDownloadPDF}
                            className={
                              media == "sm" || media == "xs"
                                ? "cursor-pointer border pt-[5px] pb-[5px] ml-3 mr-2 rounded-md border-1"
                                : // ? "cursor-pointer border pt-[5px] pb-[5px] ml-3 mr-2 rounded-md border-1"
                                  "cursor-pointer border pt-[5px] pb-[5px] rounded-md border-1"
                              // : "cursor-pointer border pt-[5px] pb-[5px] sm:pl-[5px] md:pl-[10px] pl-[5px] lg:pl-[40px] xl:pl-[40px] xxl:pl-[40px] pr-[30px] rounded-md border-1"
                            }
                            style={{
                              fontFamily: "Poppins",
                            }}
                          >
                            {downloadLoading ? (
                              <p className="flex">
                                {" "}
                                <Spin className="mr-2" /> Downloading
                              </p>
                            ) : (
                              <p
                                className={
                                  media == "sm" || media == "xs"
                                    ? "flex justify-center"
                                    : "flex justify-center"
                                }
                              >
                                <DownloadOutlined className="text-[16px] mr-3" />{" "}
                                Download
                              </p>
                            )}
                          </Col>
                        </Row>
                      )}
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>

            <Col
              span={24}
              className={
                media === "xxl"
                  ? "pt-4 pl-4 purchase-invoice-orders pb-12 pr-4"
                  : media === "md"
                  ? "mt-[-10px] pl-4 purchase-invoice-orders pb-12 pr-4"
                  : "pt-1 pl-4 purchase-invoice-orders pb-12 pr-4"
              }
            >
              <Table
                style={{
                  overflow: "hidden",
                }}
                bordered
                columns={HeaderData}
                dataSource={
                  salesItemQtyRows &&
                  salesItemQtyRows.length > 0 &&
                  !isEmpty(salesItemQtyRows[0].partyName)
                    ? salesItemQtyRows
                    : []
                }
                rowClassName={"table-row-label p-0"}
                expandable={{
                  // expandedRowRender: expandedRowRender,
                  defaultExpandAllRows: false,
                  // expandIconColumnIndex: 5,
                }}
                pagination={{
                  defaultPageSize: 10,
                  showSizeChanger: true,
                  // onShowSizeChange: (e) => console.log(e, "page limit"),
                  pageSizeOptions: ["5", "10", "20", "30"],
                  onChange: (e) => handlePagination(e),
                  // page
                  total: !isEmpty(search)
                    ? salesItemQtyRows.length
                    : sales_item_quantity_report
                    ? sales_item_quantity_report.totalItems
                    : "",
                }}
                sortDirections={"ascend"}
                loading={tableLoading ? true : false}
                showSorterTooltip={"sorter-icon"}
                scroll={{
                  y: "100%",
                  x: itemQuantityReportTable.length > 0 ? 825 : "100%",
                }}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </React.Fragment>
  );
};

SalesItemsQtyReport.propTypes = {
  location: PropTypes.any,
  itemId: PropTypes.any,
  organizationId: PropTypes.any,
  partyName: PropTypes.any,
  ledgerLoading: PropTypes.any,
};

export default SalesItemsQtyReport;
